import { faFileContract } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import LegalPageLayout from "../Components/LegalPageLayout";

function TermsSME() {
  return (
    <LegalPageLayout
      titleId="terms-sme-title"
      icon={faFileContract}
      title="Terms of Service (Smart SME)"
      description={<p>Built on trust, transparency, and responsible use.</p>}
    >
      <p className="effective-date">Effective Date: May 20, 2026</p>

      <p>
        Welcome to SmartSME. These Terms of Service ("Terms") govern your access
        to and use of the SmartSME mobile and web applications ("Service").
      </p>

      <p>By creating an account or using SmartSME, you agree to these Terms.</p>

      <h5>1. About SmartSME</h5>

      <p>
        SmartSME is a business management platform that provides tools for
        inventory management, sales and invoicing, customer and supplier
        management, employee management, expense tracking, business reporting,
        and subscription billing.
      </p>

      <p>SmartSME is operated by MileSoft ("we", "our", or "us").</p>

      <h5>2. Eligibility</h5>

      <p>
        You must be at least 18 years old and legally capable of entering into a
        binding agreement to use SmartSME.
      </p>

      <p>
        If you use SmartSME on behalf of a business or organization, you
        represent that you have authority to bind that organization to these
        Terms.
      </p>

      <h5>3. User Accounts</h5>

      <p>
        To use certain features, you must create an account. You agree to
        provide accurate information, keep your login credentials secure,
        maintain current account information, and notify us immediately of
        unauthorized access.
      </p>

      <p>
        You are responsible for all activities performed through your account.
      </p>

      <h5>4. Acceptable Use</h5>

      <p>You agree not to:</p>

      <ul>
        <li>Violate applicable laws or regulations</li>
        <li>Upload malicious software or harmful code</li>
        <li>Attempt unauthorized access to systems or data</li>
        <li>Interfere with the operation of the Service</li>
        <li>Use SmartSME to commit fraud or illegal activities</li>
        <li>Upload content that infringes intellectual property rights</li>
      </ul>

      <p>
        We reserve the right to suspend or terminate accounts that violate these
        Terms.
      </p>

      <h5>5. Business Data</h5>

      <p>
        You retain ownership of the business data you enter into SmartSME,
        including inventory records, customer records, supplier records,
        employee information, financial records, uploaded documents, and images.
      </p>

      <p>
        You grant us a limited license to store, process, and transmit such data
        solely for providing the Service.
      </p>

      <h5>6. Subscription Plans</h5>

      <p>
        SmartSME offers Free and Premium subscription plans. Premium features
        may include advanced reporting, PDF exports, multi-currency
        functionality, additional notifications, and higher usage limits.
      </p>

      <p>Subscription features and pricing may change from time to time.</p>

      <h5>7. Payments and Billing</h5>

      <p>
        Premium subscriptions are processed through third-party payment
        providers, including PayChangu.
      </p>

      <p>
        By purchasing a subscription, you agree to pay applicable fees and
        understand that payment processing is handled by third-party providers.
      </p>

      <p>
        SmartSME is not responsible for payment provider outages, delays, or
        payment processing failures.
      </p>

      <h5>8. Subscription Renewal and Expiry</h5>

      <p>
        Premium subscriptions remain active for the purchased billing period.
      </p>

      <p>
        If a subscription expires, your data remains stored, but access to
        Premium features may be restricted and Free plan limits may apply.
      </p>

      <p>We may provide a grace period before restrictions are enforced.</p>

      <h5>9. Data Backup and Availability</h5>

      <p>
        We strive to provide reliable service, but we do not guarantee
        uninterrupted availability.
      </p>

      <p>
        You are responsible for maintaining backups of critical business records
        where required.
      </p>

      <p>
        Scheduled maintenance, upgrades, technical issues, or third-party
        service outages may temporarily affect availability.
      </p>

      <h5>10. Intellectual Property</h5>

      <p>
        SmartSME, its software, logos, trademarks, designs, and content are
        owned by MileSoft and protected by intellectual property laws.
      </p>

      <p>
        You may not copy, reverse engineer, modify, redistribute, or resell any
        part of the Service without written permission.
      </p>

      <h5>11. Privacy</h5>

      <p>
        Your use of SmartSME is also governed by our Privacy Policy. Please
        review the Privacy Policy to understand how we collect, use, and protect
        information.
      </p>

      <h5>12. Third-Party Services</h5>

      <p>
        SmartSME relies on third-party services including Firebase, Google Play
        Services, PayChangu, and cloud hosting providers.
      </p>

      <p>
        We are not responsible for interruptions, failures, or issues caused by
        third-party providers.
      </p>

      <h5>13. Limitation of Liability</h5>

      <p>
        To the maximum extent permitted by law, SmartSME and MileSoft shall not
        be liable for loss of profits, loss of business opportunities, data
        loss, business interruption, or indirect, incidental, or consequential
        damages.
      </p>

      <p>Your use of the Service is at your own risk.</p>

      <h5>14. Disclaimer of Warranties</h5>

      <p>The Service is provided on an "as is" and "as available" basis.</p>

      <p>
        We do not guarantee error-free operation, continuous availability,
        accuracy of business reports, or compatibility with all devices.
      </p>

      <h5>15. Termination</h5>

      <p>
        We may suspend or terminate access if you violate these Terms, if your
        account is involved in fraudulent activity, or if required by law.
      </p>

      <p>You may stop using the Service at any time.</p>

      <h5>16. Changes to These Terms</h5>

      <p>
        We may update these Terms periodically. Continued use of SmartSME after
        changes are published constitutes acceptance of the updated Terms.
      </p>

      <h5>17. Governing Law</h5>

      <p>
        These Terms shall be governed by the laws of the Republic of Malawi.
      </p>

      <p>
        Any disputes arising from these Terms shall be subject to the
        jurisdiction of the courts of Malawi.
      </p>
      <h5>18. Refunds and Cancellations</h5>

      <p>
        SmartSME offers subscription-based services. Subscription fees are
        charged in advance for the selected billing period.
      </p>

      <p>
        Users may cancel future subscription renewals at any time through the
        application or by contacting support.
      </p>

      <p>
        Cancellation does not automatically entitle the user to a refund for the
        current subscription period.
      </p>

      <p>Refund requests may be considered on a case-by-case basis where:</p>

      <ul>
        <li>A duplicate payment was charged;</li>
        <li>A payment was processed in error;</li>
        <li>
          The Service was unavailable for an extended period due to our fault;
        </li>
        <li>A refund is otherwise required by applicable law.</li>
      </ul>

      <p>
        Approved refunds will be processed through the original payment method
        where reasonably possible.
      </p>

      <p>
        We reserve the right to refuse refund requests that do not meet the
        criteria above.
      </p>

      <h5>19. Business and Financial Information Disclaimer</h5>

      <p>
        SmartSME provides tools for recording, organizing, and reporting
        business information.
      </p>

      <p>
        SmartSME does not provide accounting, auditing, legal, tax, investment,
        or financial advisory services.
      </p>

      <p>Users remain solely responsible for:</p>

      <ul>
        <li>The accuracy of information entered into the Service;</li>
        <li>Business decisions made using the Service;</li>
        <li>Tax filings and compliance obligations;</li>
        <li>Regulatory and legal compliance;</li>
        <li>
          Verification of reports and calculations generated by the Service.
        </li>
      </ul>

      <h5>20. Data Backup Responsibility</h5>

      <p>
        SmartSME uses commercially reasonable measures to protect and preserve
        user data.
      </p>

      <p>
        However, users are encouraged to maintain independent backups of
        critical business information where appropriate.
      </p>

      <p>
        To the maximum extent permitted by law, MileSoft shall not be liable for
        loss of data resulting from:
      </p>

      <ul>
        <li>User actions or errors;</li>
        <li>Third-party service failures;</li>
        <li>Internet connectivity issues;</li>
        <li>Force majeure events;</li>
        <li>Unauthorized access beyond our reasonable control.</li>
      </ul>

      <h5>21. Service Availability</h5>

      <p>We strive to provide reliable and uninterrupted access to SmartSME.</p>

      <p>
        However, we do not guarantee that the Service will always be available,
        error-free, or uninterrupted.
      </p>

      <p>Access to the Service may be suspended or limited due to:</p>

      <ul>
        <li>Scheduled maintenance;</li>
        <li>System upgrades;</li>
        <li>Security incidents;</li>
        <li>Third-party service disruptions;</li>
        <li>Circumstances beyond our reasonable control.</li>
      </ul>

      <h5>22. Limitation of Liability</h5>

      <p>
        To the maximum extent permitted by applicable law, MileSoft, its owners,
        employees, affiliates, contractors, and partners shall not be liable
        for:
      </p>

      <ul>
        <li>Loss of profits;</li>
        <li>Loss of revenue;</li>
        <li>Loss of business opportunities;</li>
        <li>Loss of goodwill;</li>
        <li>Loss or corruption of data;</li>
        <li>Business interruption;</li>
        <li>
          Indirect, incidental, special, exemplary, punitive, or consequential
          damages.
        </li>
      </ul>

      <p>
        This limitation applies whether the claim is based on contract, tort,
        negligence, strict liability, or any other legal theory.
      </p>

      <p>
        To the maximum extent permitted by law, MileSoft's total liability
        arising out of or relating to the Service shall not exceed the total
        amount paid by the user for SmartSME subscriptions during the twelve
        (12) months preceding the event giving rise to the claim.
      </p>

      <p>
        Nothing in these Terms excludes liability that cannot be excluded under
        applicable law.
      </p>

      <h5>23. Contact Information</h5>

      <p>
        SmartSME
        <br />
        Developed by MileSoft
        <br />
        Email: <a href="mailto:terms@milesoft.africa">terms@milesoft.africa</a>
        <br />
        Malawi
      </p>
    </LegalPageLayout>
  );
}

export default TermsSME;
